module.exports = __webpack_public_path__ + "img/rubrica_simple.837c2c73.png";